(function () {
  'use strict';

  var INACTIVE = [
    { root: '.hr-request', label: '1 / 1,000 HUMAN SUPPORT' },
    { root: '.sr-request--dog', label: '1 / 100 DOG SUPPORT' }
  ];

  function disableInactiveProgram(program) {
    var root = document.querySelector(program.root);
    if (!root) return;

    document.documentElement.classList.add('sh-inactive-support-page');

    var form = document.querySelector('.contact-form__form');
    var formShell = document.querySelector('.contact-form');
    if (form) {
      form.setAttribute('aria-disabled', 'true');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      form.querySelectorAll('input, select, textarea, button').forEach(function (control) {
        control.disabled = true;
      });
    }

    if (formShell) {
      formShell.replaceChildren();
      var notice = document.createElement('section');
      notice.className = 'sh-support-closed';
      notice.setAttribute('role', 'status');
      notice.innerHTML =
        '<p class="sh-support-closed__kicker">' + program.label + ' · NOT YET ACTIVATED</p>' +
        '<h2>THIS DOORWAY<br>IS NOT OPEN YET.</h2>' +
        '<p class="sh-support-closed__copy">This support chapter remains part of the SurvivingHuman archive, but requests are currently closed. The active chapter is the 1 / 200 Parent Wish.</p>' +
        '<a class="sh-support-closed__button" href="/pages/request-parent-wish"><span>OPEN ACTIVE PARENT WISH</span><span aria-hidden="true">→</span></a>';
      formShell.appendChild(notice);
    }
  }

  function init() {
    INACTIVE.forEach(disableInactiveProgram);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
